import { render } from "./DigitCounter.vue?vue&type=template&id=654e7f52&ts=true"
import script from "./DigitCounter.vue?vue&type=script&lang=ts"
export * from "./DigitCounter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__